import type { TFunction } from "i18next";
import type { MetadataEvent } from "../../lib/metadata-history/metadata-events";
import type { MetadataTargetIdentity } from "../../lib/metadata-history/metadata-targets";
import { metadataLabels } from "../editor-panel/developer-section/metadata-form-schema";
import { metadataTargetLabel } from "../preview-canvas/metadata-target-label";

export function describeMetadataAction(event: MetadataEvent | undefined, target: MetadataTargetIdentity | undefined, t: TFunction) {
  if (!event) return "";
  if (event.type === "artwork/set") return t("builder.history.artwork");
  if (event.type === "metadata/replace") return t("metadata.history.replace");
  if (event.type === "week-dates/set") return t("builder.history.dateLayout", { count: event.globals.length });
  if (event.type === "formats/set") return t("builder.history.dateFormat");
  if (event.type === "day-dates/set") return t("builder.history.dayDates");
  if (event.type === "global/style") return t("builder.history.dateStyle", { style: event.name });
  if (event.type === "day-layout/set") {
    const actions = {
      initialize: t("builder.history.dayInitialize"),
      anchor: t("builder.history.dayAnchor"),
      placement: t("builder.history.dayPlacement"),
      rotation: t("builder.history.dayRotation"),
      exception: t("builder.history.dayException"),
      shared: t("builder.history.dayShared"),
      element: t("builder.history.dayElement"),
      copy: t("builder.history.streamCopy"),
    };
    const labels = metadataLabels(t);
    return t("builder.history.dayLayout", {
      action: actions[event.action], mode: labels[event.layout.mode],
      day: event.day ? labels[event.day] : t("builder.days.shared"),
    });
  }
  if (event.type === "style/set") {
    const labels = metadataLabels(t);
    return t("builder.history.style", { style: labels[event.name] ?? event.name, field: labels[event.field] ?? event.field });
  }
  if (event.type === "global/rotation") {
    const label = target ? metadataTargetLabel(target, metadataLabels(t)) : `globals.${event.index}`;
    return t("builder.history.rotation", { target: label });
  }
  const label = target ? metadataTargetLabel(target, metadataLabels(t)) : event.path;
  return t("metadata.history.position", { target: label });
}
